
import { Card, CardHeader, CardContent, CardTitle, CardDescription } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { Profile } from "@/hooks/useProfileData";
import { PersonalInfoDisplay } from "./PersonalInfoDisplay";
import { PersonalInfoForm } from "./PersonalInfoForm";
import { usePersonalInfo } from "./hooks/usePersonalInfo";

interface PersonalInfoCardProps {
  profile: Profile;
  isLoading: boolean;
  setIsLoading: (loading: boolean) => void;
  onProfileUpdate: (profile: Profile) => void;
}

export function PersonalInfoCard({ 
  profile, 
  isLoading, 
  setIsLoading, 
  onProfileUpdate 
}: PersonalInfoCardProps) {
  const {
    isEditing,
    setIsEditing,
    form,
    handleSave,
    handleCancel
  } = usePersonalInfo(profile, isLoading, setIsLoading, onProfileUpdate);

  return (
    <Card className="backdrop-blur-lg bg-white/10 border-white/20 h-full flex flex-col">
      <CardHeader className="flex flex-row items-center justify-between">
        <div>
          <CardTitle className="text-white">Personal Information</CardTitle>
          <CardDescription className="text-white/70">
            Update your personal details
          </CardDescription>
        </div>
        {!isEditing && (
          <Button
            variant="outline"
            className="bg-white/10 border-white/20 text-white hover:bg-white/20"
            onClick={setIsEditing}
            type="button"
          >
            Edit
          </Button>
        )}
      </CardHeader>
      <CardContent className="space-y-4 flex-1">
        {isEditing ? (
          <PersonalInfoForm
            form={form}
            isLoading={isLoading}
            userEmail={profile.email} // Pass the email to the form
            onSave={handleSave}
            onCancel={handleCancel}
          />
        ) : (
          <PersonalInfoDisplay profile={profile} />
        )}
      </CardContent>
    </Card>
  );
}
